import React from 'react';
import { HStack, Text, Icon, Box } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FiCopy } from 'react-icons/fi';
import { useAlert } from '../../hooks/useAlert';
import { useTranslation } from '../../hooks/useTranslation';

interface RequisiteItemProps {
    value: string;
    label?: string;
    icon?: IconType;
}

const RequisiteItem: React.FC<RequisiteItemProps> = ({ value, label, icon }) => {
    const { success } = useAlert();
    const { t } = useTranslation();

    const handleCopy = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            success(t.pages.support.copied);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <HStack justify="space-between" w="full" align="center">
            <HStack gap={2} align="center" flex={1}>
                {icon && <Icon as={icon} boxSize={4} color="black" minW={8} alignSelf="right" />}
                {label && (
                    <Text fontWeight="medium" minW={8} textAlign="right">
                        {label}
                    </Text>
                )}
                <Text>{value}</Text>
            </HStack>
            <Box
                as="button"
                onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(value);
                }}
                p={1}
                borderRadius="md"
                _hover={{ bg: 'gray.100' }}
                transition="background 0.2s"
                cursor="pointer"
            >
                <Icon as={FiCopy} boxSize={4} color="gray.500" />
            </Box>
        </HStack>
    );
};

export default RequisiteItem;
